import { env } from './EnvironmentConfig'

export const APP_NAME = 'Corp';
// export const API_BASE_URL = env.API_ENDPOINT_URL
export const API_BASE_URL = env.API_ENDPOINT_URL